import { FONTS } from '@styles/fonts'
import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import styled, { css } from 'styled-components'

export const Gallery = styled.div`
  position: fixed;
  z-index: 9999;
  width: 100%;
  height: 100%;
  display: flex;
  left: 0;
  top: 0;
  overflow-y: auto;
  background: ${COLORS.white};

  .slick-arrow.slick-prev {
    left: 25px;
  }

  .slick-arrow.slick-next {
    right: 25px;
  }

  @media ${DEVICES.tabletMini} {
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;

    > div:nth-child(2) {
      height: 420px;
      width: calc(100% - 32px);
      flex: unset;
      margin: auto;
    }

    .slick-arrow.slick-prev {
      left: 15px;
    }

    .slick-arrow.slick-next {
      right: 15px;
    }
  }

  @media ${DEVICES.mobile} {
    > div:nth-child(2) {
      height: 50vh;
      max-height: 264px;
    }
  }
`

export const GalleryInfo = styled.div`
  background: ${COLORS.white};
  width: 352px;
  flex: 0 0 352px;
  padding: 32px 28px 44px;
  position: relative;

  h1 {
    font-size: 22px;
    line-height: 30px;
  }

  .share-button {
    position: absolute;
    bottom: 45px;
    left: 25px;
  }

  @media ${DEVICES.tabletMini} {
    width: 100%;
    padding: 0 16px 44px;
    justify-content: flex-end;
    display: flex;
    flex-direction: column;
    flex: unset;

    .share-button {
      position: relative;
      bottom: auto;
      left: auto;
    }
  }
`

export const GalleryInfoHeading = styled.div`
  align-items: center;
  justify-content: space-between;
  margin-bottom: 65px;
  color: ${COLORS.secondary};
  width: 100%;
  display: none;

  @media ${DEVICES.tabletMini} {
    display: flex;
    margin-bottom: 0;
    padding: 10px 16px 0;
  }  
  
  @media ${DEVICES.mobile} {
    margin-top: 75px;
  }

  ${({ hideOnMobile }) =>
    hideOnMobile &&
    css`
      display: flex;

      @media ${DEVICES.tabletMini} {
        display: none;
      }
    `}
`

export const GalleryInfoBody = styled.div`
  @media ${DEVICES.tabletMini} {
    justify-content: flex-end;
    display: flex;
    flex-direction: column;

    > div:first-child {
      display: none;
    }
  }
`

export const GalleryInfoProperty = styled.div``

export const Count = styled.div`
  font-size: 14px;
  line-height: 20px;
`

export const GalleryButtons = styled.div`
  padding-top: 22%;

  button {
    margin-bottom: 12px;
  }

  @media ${DEVICES.tabletMini} {
    padding-top: 0;
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;

    button {
      margin: 0 7px;
      white-space: nowrap;
    }
  }
`

export const BackButton = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-family: ${FONTS.medium};
  cursor: pointer;
  text-decoration: underline;
  transition: all 0.25s ease-in;

  &:hover {
    color: ${COLORS.primary};
  }

  svg {
    margin-right: 5px;
  }
`

export const Logo = styled.div`
  margin-bottom: 20px;
  justify-content: center;
  display: flex;
  
  img {
    height: 50px;
  }

  @media ${DEVICES.mobile} {
    margin-bottom: 0;
    padding-top: 10px;
  }

  @media ${DEVICES.tabletMini} {
    margin-bottom: 0;
    padding-top: 10px;
  }

  ${({ hideOnMobile }) =>
    hideOnMobile &&
    css`
      @media ${DEVICES.mobile} {
        display: none;
      }

      @media ${DEVICES.tabletMini} {
        display: none;
      }
    `}
`
